import type { Program } from 'models';
import { useState } from 'react';
import { AddLine, Button, CheckLineIcon, Flex, QuestionLineIcon, Text } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { ProgramInviteModal } from 'features/programs/program-invite-modal';
import { useProgramsPermissions } from 'permissions/programs';
import { Filter } from '../filter';

export type ProgramMembersSortBy = 'invited_at' | 'joined_at' | 'name';

const sortItems = [
  {
    key: 'joined_at',
    name: 'Date Enrolled',
  },
  {
    key: 'name',
    name: 'Alphabetically',
  },
  {
    key: 'invited_at',
    name: 'Date Invited',
  },
];

type P = {
  joinedCount: number;
  onSort: (key: ProgramMembersSortBy) => void;
  pendingCount: number;
  program: Program;
  sortBy: ProgramMembersSortBy;
};

const MembersHeader = ({ joinedCount, onSort, pendingCount, program, sortBy }: P) => {
  const { canInviteProgramMembers } = useProgramsPermissions();
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);

  return (
    <Flex align="center" flex="1" justify="space-between">
      <Flex gap="large" orientation="horizontal">
        <Flex align="center" gap="xs" vertical>
          <span className="members-header__status-icon">
            <CheckLineIcon className="members-header__status-icon-glyph" size="extra-small" />
          </span>
          <Text size="large" weight="base">
            {joinedCount} Joined
          </Text>
        </Flex>
        <Flex align="center" gap="xs" vertical>
          <span className="members-header__status-icon">
            <QuestionLineIcon className="members-header__status-icon-glyph" size="extra-small" />
          </span>
          <Text size="large" weight="base">
            {pendingCount} Pending
          </Text>
        </Flex>
      </Flex>
      <Filter filter={sortBy} items={sortItems} onSort={onSort} />
      {canInviteProgramMembers({ program }) ? (
        <Button
          icon={<AddLine />}
          onClick={() => {
            setIsInviteModalOpen(true);
          }}
          size="large"
        >
          Enroll Members
        </Button>
      ) : null}

      <ProgramInviteModal
        isOpened={isInviteModalOpen}
        onClose={() => {
          setIsInviteModalOpen(false);
        }}
        programId={program.id}
      />
    </Flex>
  );
};

export default MembersHeader;
